import { Auth } from 'aws-amplify'
import { Camp } from '../components/SimSumHelpers'
import { graphql } from 'gatsby'
import Layout from '../layouts/layout'
import Masonry from 'react-masonry-css'
import React from 'react'
import SEO from '../components/seo'
import qs from 'qs'
import ribbon from '../images/ribbon.svg'
import shape1 from '../images/shape-1.svg'
import shape2 from '../images/shape-2.svg'
import shape3 from '../images/shape-3.svg'
import slugify from 'slugify'
import moment from 'moment'
import breakHeroImage from '../images/sacramento-hero-river.jpg'

const _ = require('lodash')

class CurationDetails extends React.PureComponent {
  render () {
    const imageUrl = this.props.curation.indexImage && this.props.curation.indexImage.file && this.props.curation.indexImage.file.url
    return (
      <a href={`/curated/${ slugify(this.props.curation.name, { replacement: '-', remove: /[^A-Za-z0-9 ]/g, lower: true }) }`}>
        <div className="camp card slideshow shadow-sm ss-4">
          { imageUrl && <img className="card-img-top" src={ imageUrl } /> }
          <div className="card-footer text-center">
            <h6 className="m-0">{this.props.curation.name}</h6>
          </div>
        </div>
      </a>
    )
  }
}

class CampDetails extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    const campImage = (() => {
        if ( this.props.camp.image ) {
            return <img className="img-fluid rounded mb-3 shadow-sm border" src={ this.props.camp.image } alt="camp detail imagery" />
        }
    })()

    const daysTillNotFresh = 7;
    let newBadge;
    if (this.props.camp.updatedAt != undefined) {
        const freshness = moment().diff(moment(this.props.camp.updatedAt), "days") <= daysTillNotFresh;
        newBadge = freshness ? <><p className="new-camp">Added in the past {daysTillNotFresh} days</p></> : null;
    } else {
        newBadge = null;
    }


    return (
      <div className="camp card slideshow shadow-sm ss-4" key={ this.props.camp.id } id={ this.props.camp.id }>
        <a href={ this.props.camp.slug }>
          <div className="ribbon"><img src={ ribbon } /></div>
          <div className="card-body">
            { campImage }
            { newBadge }
            <h5 className="card-heading">{ this.props.camp.name }</h5>
            <h6 className="card-subheading">{ this.props.camp.organization.name }</h6>
            <div className="d-none d-lg-block">{ this.props.camp.summary }</div>
          </div>
          <div className="card-footer d-none d-lg-block">
            <div className="small font-italic summary">{ this.props.camp.snapshot() }</div>
          </div>
        </a>
      </div>
    )
  }
}

class PageContent extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      user: null,
      searchTerm: '',
      promotedCamps: [],
      exploreCamps: [],
    }

    this.onSubmit = this.onSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount = async () => {
    // Local preview: append ?empty=explore or ?empty=featured (or ?empty=all) to
    // the URL to force those sections into their empty state.
    const params = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null
    const empty = params ? (params.get('empty') || '') : ''
    const forceEmptyExplore = empty === 'explore' || empty === 'all'
    const forceEmptyFeatured = empty === 'featured' || empty === 'all'

    this.setState({
      promotedCamps: forceEmptyFeatured ? [] : _.sampleSize(this.props.data.allContentfulCamp.edges, 25),
    })
    const feedEdge = this.props.data.allContentfulCuratedListFeed.edges[0]
    this.setState({
      exploreCamps: forceEmptyExplore ? [] : ((feedEdge && feedEdge.node.curatedLists) || []),
    })
    await Auth.currentAuthenticatedUser()
      .then(response => {
        this.setState({ user: response })
      }).catch(err => {
        console.log(err)
        this.setState({ user: null })
      })
  }

  onSubmit (event) {
    event.preventDefault()
    window.location.assign(`/search/#${ qs.stringify({ term: this.state.searchTerm || undefined }) }`)
  }

  handleChange (event) {
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  render () {
    const ctaButton = this.state.user != null ? (<a href="/search/"><button type="button" className='btn btn-cta'>Get Started</button></a>) : (<a href="/account/"><button type="button" className='btn btn-cta'>Sign In or Sign Up</button></a>)
    const heroStyle = {
      backgroundImage: `url(${breakHeroImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center 80%',
      backgroundRepeat: 'no-repeat',
      minHeight: '85vh',
      display: 'flex',
      alignItems: 'flex-start',
      color: 'white',
      textShadow: '1px 1px 4px rgba(0,0,0,0.4)',
    }
    return (
      <Layout location={this.props.location}>
        <SEO title="Sacramento Summer Camp Directory" keywords={[`simple`, `summer camps`, `sacramento`]} />

        {/* intro */}
        <div className="container-fluid homepage-hero" style={heroStyle}>
          <div className="container pt-4">
            <div className="row">
              <div className="col-md-6 col-lg-5 col-12">
                <div className="homepage-hero--inner py-4 px-4 mt-md-4" style={{ backgroundColor: 'rgba(0, 82, 255, 0.85)', borderRadius: '4px' }}>
                  <h1 className="font-weight-bold mb-3" style={{ fontSize: '2.5rem', lineHeight: '1.1' }}>Camp season&apos;s<br />a wrap.</h1>
                  <h3 className="font-weight-bold mb-2" style={{ fontSize: '1.5rem', lineHeight: '1.4', color: '#FFCB00' }}>I&apos;m already digging<br />into next year.</h3>
                  <p className="lead" style={{ fontSize: '1.25rem', lineHeight: '1.4', fontWeight: '500', marginBottom: '1.5rem' }}>
                    The 2026 directory is closed for the season, but the research never stops. Get on the list and you&apos;ll be first in when the 2027 camps go live, plus the good finds in between.
                  </p>
                  <a href="https://tally.so/r/D4xY7q"><button type="button" className="btn btn-cta">Get on the list</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid">
          <div className="container pt-5 pb-5">
            <div className="row">
              <div className="col-12 text-center">
                <h2 className="mb-4">We do the hard work.</h2>
              </div>
              <div className="col-12 col-sm-4 text-center">
                <div className="camp card slideshow shadow-sm ss-4">
                  <img className="card-img-top" src={ shape1 } />
                  <div className="card-footer text-center">
                    <p className="m-0">Every local camp worth knowing, in one place.</p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-4 text-center">
                <div className="camp card slideshow shadow-sm ss-4">
                  <img className="card-img-top" src={ shape2 } />
                  <div className="card-footer text-center">
                    <p className="m-0">Simple searching, filtering, and saving of camps.</p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-4 text-center">
                <div className="camp card slideshow shadow-sm ss-4">
                  <img className="card-img-top" src={ shape3 } />
                  <div className="card-footer text-center">
                    <p className="m-0">Build your camp schedule, then add to calendar.</p>
                  </div>
                </div>
              </div>
              <div className="col-12 text-center pt-3">
                { ctaButton }
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid">
          <div className="container pb-5">
            <div className="row justify-content-center">
              <div className="col-12 text-center">
                <h2>Explore</h2>
                <div className="pb-3 mx-auto" style={{ maxWidth: '46ch', textWrap: 'pretty' }}>
                  {this.state.exploreCamps.length > 0
                    ? "Not sure where to start? Browse some of our curated lists!"
                    : "The 2027 directory is in the works, with fresh curated lists on the way. Get on the list and you'll be first to know when they land."}
                </div>
              </div>
              {this.state.exploreCamps.map((curationData, index) => (<div className="col-sm-4 col-md-3 pb-3" key={index}><CurationDetails curation={curationData} /></div>))}
              {this.state.exploreCamps.length === 0 && (
                <div className="col-12 text-center pb-3">
                  <a href="https://tally.so/r/D4xY7q"><button type="button" className="btn btn-cta">Get on the list</button></a>
                </div>
              )}
            </div>
          </div>
        </div>

        {this.state.promotedCamps.length > 0 && (
          <div className="container-fluid">
            <div className="container pb-5">
              <div className="row">
                <div className="col-12 text-center">
                  <h2>Featured Camps</h2>
                </div>
                <div className="col-12">
                  <Masonry breakpointCols={{ default: 4, 992: 3, 768: 2, 576: 1 }} className="simsum-masonry-grid" columnClassName="simsum-masonry-grid-column">
                    {this.state.promotedCamps.map((campData, index) => (<CampDetails camp={ new Camp(campData.node) } key={index} />))}
                  </Masonry>
                </div>
              </div>
            </div>
          </div>
        )}

      </Layout>
    )
  }
}

export default PageContent

export const query = graphql`
  {
    allContentfulCuratedListFeed(filter: {name: {eq: "Homepage"}}) {
      edges {
        node {
          id
          name
          curatedLists {
            id
            name
            indexImage {
              file {
                url
              }
            }
          }
        }
      }
    }
    allContentfulCamp (
      filter: {
        isFeatured: {eq: true}
      }
    ) {
      edges {
        node {
          contentful_id
          updatedAt
          name
          summary
          isFeatured
          organization {
            contentful_id
            name
            accountTier
          }
          images {
            file {
              url
            }
          }
          sessions {
            contentful_id
            name
            minGrade
            maxGrade
            minAge
            maxAge
            price
            startDate
            endDate
            address {
              location {
                lat
                lon
              }
              city
            }
          }
        }
      }
    }
  }
`
